import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router'
import Validation from "../hoc/Validation";
import { sendFeedback, getVisitorCount, getUpdatedOn } from '../../actions/accountAction'
import store from "../../store";
import preval from 'preval.macro'
import StarRatings from 'react-star-ratings'
import { setNotification } from '../../actions/employerAction';

let baseUrl = window.location.origin;

let websiteUrl, cmsUrl;

// if (baseUrl == "localhost") {
//     websiteUrl = baseUrl;
//     cmsUrl = "http://uatcms.pgrkam.com"
// }
// else if (baseUrl == "uatweb.pgrkam.com") {
//     websiteUrl = baseUrl;
//     cmsUrl = "http://uatcms.pgrkam.com"
// }
// else if (baseUrl == "pgrkam.com") {
//     websiteUrl = baseUrl;
//     cmsUrl = "http://cms.pgrkam.com"
// }
// else {
//     websiteUrl = baseUrl;
//     cmsUrl = "http://uatcms.pgrkam.com"
// }

cmsUrl = "http://cms.pgrkam.com";

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basePath: window.location.protocol + '//' + window.location.host + '/',
            formData: [],
            error: ''
        }
        this.feedbackRef = React.createRef();
        this.disclaimer = React.createRef();
        store.dispatch(getVisitorCount());
        store.dispatch(getUpdatedOn());


    }

    // submit = async (e) => {
    //     e.preventDefault()

    //     const authKey = localStorage.getItem("token");

    //     // ✅ Check if user is not logged in
    //     if (!authKey) {
    //         alert("Please log in before submitting feedback."); // or use your own notification method
    //         return;
    //     }
    //     if (this.props.validator.allValid()) {
    //         await store.dispatch(sendFeedback(this.state.formData))
    //         await this.props.validator.hideMessages()
    //         this.setState({ formData: [] })
    //         this.feedbackRef.current.click()
    //     } else {
    //         this.props.validator.showMessages();
    //         this.forceUpdate();
    //     }
    // }

    submit = async (e) => {
        e.preventDefault();

        // ✅ Try both common key names
        const authKey =
            localStorage.getItem("token") || localStorage.getItem("auth_key");

        // ✅ If still missing, show alert and stop
        if (!authKey || authKey === "null" || authKey === "undefined") {
            // alert("You must be logged in before submitting feedback.");
            this.props.dispatch(
                setNotification({
                    type: "error",
                    message: "Please log in before submitting feedback."
                })
            );
            this.feedbackRef?.current?.click();
            return;
        }

        // ✅ Proceed if valid
        if (this.props.validator.allValid()) {
            try {
                // Attach token to form data
                const formDataWithAuth = {
                    ...this.state.formData,
                    auth_key: authKey,
                };

                await store.dispatch(sendFeedback(formDataWithAuth));

                await this.props.validator.hideMessages();

                this.setState({ formData: {} }); // reset form
                this.feedbackRef?.current?.click(); // trigger ref if exists
            } catch (err) {
                console.error("Error submitting feedback:", err);
                alert("Something went wrong while submitting feedback. Please try again.");
            }
        } else {
            this.props.validator.showMessages();
            this.forceUpdate();
        }
    };


    ratingChanged = (val) => {
        const formData = this.state.formData
        formData['rating'] = val
        this.setState({ formData })
    }

    change = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let formData = this.state.formData;

        formData[name] = value;
        this.setState({ formData: formData });
    }



    render() {
        const { validator } = this.props
        const { formData } = this.state

        return (
            <footer className="clearfix">
                <div className="clearfix"></div>
                {this.props.location === '/' &&
                    <section className="client-logos text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="Logo of Pradhan Mantri Kaushal Vikas Yojana - PMKVY official site" src="/images/banner1.png" className="img-fluid align-self-center mx-auto" />

                                </div>
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="Logo of Ministry of Skill Development and Entrepreneurship - Government of India" src="/images/banner3.png" className="img-fluid align-self-center mx-auto" />
                                </div>
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="Logo of National Portal of India - india.gov.in" src="/images/banner4.png" className="img-fluid align-self-center mx-auto" />
                                </div>
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="Logo of Punjab Government Employment Portal" src="/images/banner5.png" className="img-fluid align-self-center mx-auto" />
                                </div>
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="banner-img" src="/images/banner6.jpg" className="img-fluid align-self-center mx-auto" />
                                </div>
                                <div className="col-md-2 col-sm-4 col-lg-2 d-flex">
                                    <img alt="banner-img" src="/images/banner7.png" className="img-fluid align-self-center mx-auto" />
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {/* New Footer Karan SIde */}

                <section className="upper-footer footer-change">
                    <div className="container">
                        <div className="main-footer">

                            <ul className="footer-links-listing spacebox crsrpo">
                                <li className="footer-list-item">
                                    <a
                                        aria-label="Punjab Rozgar Department Logo"
                                        className="centerimg"><img src="/images/logo-header.svg" class="img-footer-log" alt="Punjab Rozgar Department" /></a>
                                </li>
                                <li className="footer-list-item footer-title mb-2">
                                    <Link class="d-block">
                                        <span className="updatedtitle">{this.props.t('footer.updatedOn', { param: 'react' })}</span>
                                        {/* <span className="newdate-title">{preval`module.exports = (new Date().getDate())+"/"+(new Date().getMonth()+1)+"/"+(new Date().getFullYear());`}</span> */}
                                        <span className="newdate-title">{this.props.actionReducer.updatedOn &&
                                            new Date(this.props.actionReducer.updatedOn)
                                                .toLocaleDateString('en-GB')}</span>
                                    </Link>
                                </li>
                                <li className="footer-list-item footer-title">
                                    <a
                                        aria-label="Website Visitor Count"
                                        class="d-block">
                                        <span className="updatedtitle">{this.props.t('footer.visitCount', { param: 'react' })}:</span>
                                        <span className="number-title">
                                            {this.props.actionReducer.visitorsCount && this.props.actionReducer.visitorsCount}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <ul className="footer-links-listing crsrpo">
                                <li className="footer-list-item footer-title"><a aria-label="Contact Us section">{this.props.t('footer.contactUs', { param: 'react' })}</a></li>
                                <li className="footer-list-item boldfont"><a aria-label="Punjab Ghar Ghar Rozgar and Karobar Mission">{this.props.t('footer.punjabGharGharMission', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Location: SCO 149-152, 2nd Floor, Sector 17C, Chandigarh"><i className="fa fa-map-marker pe-2 pt-1" aria-hidden="true"></i> {this.props.t('footer.punjabAddress', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Email Punjab Ghar Ghar Rozgar and Karobar Mission"><i className="fa fa-envelope-o pe-2 pt-1" aria-hidden="true"></i> {this.props.t('footer.punjabEmail', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Call Punjab Ghar Ghar Rozgar and Karobar Mission"><i className="fa fa-phone pe-2 pt-1" aria-hidden="true"></i> {this.props.t('footer.punjabPhone', { param: 'react' })}</a></li>
                                <li className="footer-list-item boldfont pt-2"><a aria-label="Punjab Skill Development Mission">{this.props.t('footer.punjabDevMission', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Location: SCO 149-152, 2nd Floor, Sector-17C, Chandigarh"><i className="fa fa-map-marker pe-2 pt-1" aria-hidden="true"></i> {this.props.t('footer.punjabDevAdd', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Email Punjab Skill Development Mission"> <i className="fa fa-envelope-o pe-2 pt-1" aria-hidden="true"></i> {this.props.t('footer.punjabDevEmail', { param: 'react' })}</a></li>
                                <li className="footer-list-item"><a aria-label="Call Punjab Skill Development Mission"><i className="fa fa-phone pe-2 pt-1" aria-hidden="true"></i>  {this.props.t('footer.punjabDevPhone', { param: 'react' })}</a></li>
                                {/* <li>
                                    <div class="footer-icons">
                                        <a className='crsrpoad mb-2' aria-label="Follow us on social media"><b>{this.props.t('footer.followUs', { param: 'react' })}</b></a>
                                        {this.props.actionReducer.medialist && this.props.actionReducer.medialist.map((media, index) => (

                                            <button
                                                key={index}
                                                type="button"
                                                className={`btn btn-link mnbtn ${media.platform_name}`}
                                                data-toggle="modal"
                                                data-target="#exampleSocialModal"
                                                onClick={() => {
                                                    this.setState({ media_url: media.platform_url });
                                                }}
                                                aria-label={media.aria_label}
                                            >
                                                <i className={`fa ${media.icon_class}`} role="presentation" aria-hidden="true"></i>
                                            </button>
                                        ))}

                                        <div className="modal fade" id="exampleSocialModal" role="dialog" aria-labelledby="exampleSocialModalLabel" aria-hidden="true" >
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header border-bottom-0">

                                                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"></button>

                                                    </div>

                                                    <div class="modal-body py-0">
                                                        <p className='fSize18'>You are being redirected to an external website. Please note that Punjab Rozgar Department Website cannot be held responsible for external websites.</p>
                                                    </div>

                                                    <div className="modal-footer border-top-0">
                                                        <button
                                                            aria-label='Proceed to external website'
                                                            type="button" className="btn btn-success" onClick={() => {

                                                                window.open(this.state.media_url, "_blank"); // Opens in a new tab

                                                            }} data-dismiss="modal" >Proceed</button>
                                                        <button
                                                            aria-label='Cancel and stay on current page'
                                                            type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </li> */}

                                <li>
                                    <div className="footer-icons">
                                        <a className="crsrpoad mb-2" aria-label="Follow us on social media">
                                            <b>{this.props.t('footer.followUs', { param: 'react' })}</b>
                                        </a>

                                        {this.props.actionReducer.medialist &&
                                            this.props.actionReducer.medialist.map((media, index) => (
                                                <React.Fragment key={index}>
                                                    {/* Each button opens its own modal with unique ID */}
                                                    <button
                                                        type="button"
                                                        className={`btn btn-link mnbtn ${media.platform_name}`}
                                                        data-toggle="modal"
                                                        data-target={`#socialModal-${index}`}
                                                        aria-label={media.aria_label}
                                                    >
                                                        <i
                                                            className={`fa ${media.icon_class}`}
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </button>

                                                    {/* Unique modal per icon */}
                                                    <div
                                                        className="modal fade"
                                                        id={`socialModal-${index}`}
                                                        role="dialog"
                                                        aria-labelledby={`socialModalLabel-${index}`}
                                                        aria-hidden="true"
                                                    >
                                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                                            <div className="modal-content">
                                                                <p id={`socialModalLabel-${index}`} className="modeltitlenone">
                                                                    External Website Notification
                                                                </p>
                                                                <div className="modal-header border-bottom-0">
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close border-none"
                                                                        data-dismiss="modal"
                                                                        aria-label="Close"
                                                                    ></button>
                                                                </div>

                                                                <div className="modal-body py-0">
                                                                    <p className="fSize18">
                                                                        You are being redirected to an external website. Please note
                                                                        that Punjab Rozgar Department Website cannot be held
                                                                        responsible for external websites.
                                                                    </p>
                                                                </div>

                                                                <div className="modal-footer border-top-0">
                                                                    <button
                                                                        aria-label="Proceed to external website"
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => window.open(media.platform_url, "_blank")}
                                                                        data-dismiss="modal"
                                                                    >
                                                                        Proceed
                                                                    </button>
                                                                    <button
                                                                        aria-label="Cancel and stay on current page"
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        data-dismiss="modal"
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ))}
                                    </div>
                                </li>

                            </ul>
                            <div>
                                {/* <ul className="footer-links-listing pb-3">
                                    <li className="footer-list-item footer-title"><a>Company</a></li>
                                    <div className="gridtowbox">
                                        <li className="footer-list-item"><a>Punjab Rozgar Department</a></li>
                                        <li className="footer-list-item"><a>PSDM</a></li>
                                    </div>
                                    <li className="footer-list-item"><a>Employment Department</a></li>
                                </ul> */}
                                <ul className="footer-links-listing leftspaceing">
                                    <li className="footer-list-item footer-title"><a className='crsrpoad' aria-label='About and Policies section' >{this.props.t('footer.about_policies_title', { param: 'react' })} </a></li>
                                    {/* <div className="gridtowbox"> */}
                                    {/* <li className="footer-list-item">
                                        <Link to="/about">{this.props.t('footer.about_pgrkam', { param: 'react' })}</Link>
                                    </li> */}
                                    <li className="footer-list-item">
                                        <Link to="/copyright-policy" aria-label="View Copyright Policy">{this.props.t('footer.copyright', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item">
                                        <Link to="/privacy-policy" aria-label="View Privacy Policy"> {this.props.t('footer.privacy_policy', { param: 'react' })}</Link>
                                    </li>
                                    {/* <li className="footer-list-item">
                                        <Link to="/terms-&-conditions" aria-label="View Terms & Conditions"> {this.props.t('footer.term_and_condition', { param: 'react' })}</Link>
                                    </li> */}
                                    <li className="footer-list-item">
                                        <a
                                            // href="https://uatcms.pgrkam.com/terms-&-conditions"
                                            // href="https://cms.pgrkam.com/terms-&-conditions"
                                            href={`${cmsUrl}/terms-&-conditions`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="View Terms & Conditions"
                                        >
                                            {this.props.t('footer.term_and_condition', { param: 'react' })}
                                        </a>
                                    </li>
                                    <li className="footer-list-item">
                                        <Link to="/website-policy" aria-label="View Website Policy"> {this.props.t('footer.website_policy', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item">
                                        <Link to="/archival" aria-label="View Archival Policy">{this.props.t('footer.archival_policy', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item"><a href="/faq" aria-label="View Frequently Asked Questions">{this.props.t('footer.faq', { param: 'react' })}</a></li>
                                    {/* <li className="footer-list-item">
                                        <Link to="/contact-us">
                                            {this.props.t('footer.contact_support_team', { param: 'react' })}
                                        </Link>
                                    </li> */}
                                    <li className="footer-list-item">
                                        <Link to="/sitemap" aria-label="View Sitemap">  {this.props.t('footer.Sitemap', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item">
                                        <Link to="/help" aria-label="Get Help">  {this.props.t('footer.Help', { param: 'react' })}</Link>
                                    </li>
                                    {/* <li className="footer-list-item" data-toggle="modal" onClick={() => {
                                        this.setState({ formData: [] })
                                        this.props.validator.hideMessages()
                                    }} data-target="#feedbackModal">

                                        <Link aria-label="Give Feedback via modal">{this.props.t('footer.give_feedback', { param: 'react' })}</Link>

                                    </li> */}
                                    <li className="footer-list-item">
                                        <Link to="/feedback-form" aria-label="Submit Feedback or Grievances">{this.props.t('footer.feedback', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item">
                                        <a
                                            // href="https://uatcms.pgrkam.com/ai-tools-unicef" 
                                            // href="https://cms.pgrkam.com/ai-tools-unicef"
                                            href={`${cmsUrl}/ai-tools-unicef`}
                                            aria-label="Open AI Tools Unicef in a new tab">{this.props.t('footer.ai_tool', { param: 'react' })}</a>
                                    </li>
                                    <li className="footer-list-item">
                                        <Link to="/career-opportunities" aria-label="View Career Information">  {this.props.t('footer.career_info', { param: 'react' })}</Link>
                                    </li>

                                    <li className="footer-list-item">
                                        <Link to="/contact-us" aria-label="Contact Us page">  {this.props.t('footer.contact_us', { param: 'react' })}</Link>
                                    </li>
                                    <li className="footer-list-item">
                                        {/* <Link to="uatcms.pgrkam.com/web-information-manager-(wim)" aria-label="Web Information Manager (WIM)">  {this.props.t('footer.webinfo_wim', { param: 'react' })}</Link> */}
                                        <a
                                            // href="https://uatcms.pgrkam.com/web-information-manager-(wim)"
                                            // href="https://cms.pgrkam.com/web-information-manager-(wim)"
                                            href={`${cmsUrl}/web-information-manager-(wim)`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Web Information Manager (WIM)"
                                        >
                                            {this.props.t('footer.webinfo_wim', { param: 'react' })}
                                        </a>
                                    </li>
                                    {/* </div> */}
                                </ul>
                            </div>

                            {/* Plz Do not Dlt This Code */}
                            {/* <ul className="footer-links-listing leftspaceing">
                                <li className="footer-list-item footer-title"><a>Government Portals</a></li>
                                <li className="footer-list-item"><a href="https://punjab.gov.in">Punjab Government Official Website</a></li>
                                <li className="footer-list-item"><a href="https://www.india.gov.in">India.gov.in – National Portal of India</a></li>
                                <li className="footer-list-item"><a href="https://labour.gov.in">Ministry of Labour and Employment</a></li>
                                <li className="footer-list-item"><a href="https://skillindia.gov.in">Skill India Portal</a></li>
                                <li className="footer-list-item"><a href="https://www.ncs.gov.in">National Career Service</a></li>
                                <li className="footer-list-item"><a href="https://www.digilocker.gov.in">DigiLocker</a></li>
                                <li className="footer-list-item"><a href="https://www.mygov.in">MyGov</a></li>
                            </ul> */}
                        </div>
                    </div>
                </section>



                {/* Feedback modal*/}
                <div className="modal" id="feedbackModal" ref={this.feedbackRef}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">{this.props.t('feedback.title', { param: 'react' })}</h4>

                                <button
                                    aria-label='Close feedback form'
                                    type="button" className="btn-close" data-dismiss="modal"> </button>
                            </div>

                            <div className="modal-body">
                                <form onSubmit={this.submit} role="form" aria-label="Feedback Form">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label>
                                                    {this.props.t('forms.username', { param: 'react' })} :
                                                    <span className="errorclr ml-2" aria-hidden="true">*</span>
                                                    <span className="sr-only">required</span>
                                                </label>
                                                <input
                                                    autoComplete='username'
                                                    id="username"
                                                    type="text"
                                                    className="w-100 form-control form-control-lg mb-1"
                                                    onChange={this.change}
                                                    value={formData.username || ''}
                                                    placeholder={this.props.t('forms.enterUsername', { param: 'react' })}
                                                    name="username"
                                                    aria-label='Enter username'
                                                    aria-required="true"
                                                />
                                                {validator.message('username', formData.username, 'required')}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label>
                                                    {this.props.t('profileDetails.mobile', { param: 'react' })} :
                                                    <span className="errorclr ml-2" aria-hidden="true">*</span>
                                                    <span className="sr-only">required</span>
                                                </label>
                                                <input
                                                    id="mobile"
                                                    type="tel"
                                                    className="w-100 form-control form-control-lg mb-1"
                                                    onChange={this.change}
                                                    value={formData.mobile || ''}
                                                    placeholder={this.props.t('forms.10mobile', { param: 'react' })}
                                                    name="mobile"
                                                    aria-label='Enter mobile'
                                                    aria-required="true"
                                                />
                                                {validator.message('mobile', formData.mobile, 'required|phone')}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group mb-0">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label>
                                                    {this.props.t('profileDetails.QueryType', { param: 'react' })} :
                                                    <span className="errorclr ml-2" aria-hidden="true">*</span>
                                                    <span className="sr-only">required</span>
                                                </label>
                                                <select
                                                    className="form-select mb-3"
                                                    aria-label="Select Query Type"
                                                    name="queryType"
                                                    id="queryType"
                                                    aria-required="true"
                                                    onChange={this.change}
                                                    value={formData.queryType || ''}
                                                >
                                                    <option value="" disabled>Select Option</option>
                                                    <option value="1">Technical Query</option>
                                                    <option value="2">Other</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label htmlFor="rating">Rating :</label>
                                                <div id="rating" role="radiogroup" aria-label="Star Rating">
                                                    <StarRatings
                                                        rating={formData.rating}
                                                        numberOfStars={5}
                                                        name="rating"
                                                        starDimension="30px"
                                                        starRatedColor="rgb(255, 215, 0)"
                                                        starHoverColor="rgb(255, 215, 0)"
                                                        changeRating={this.ratingChanged}
                                                    />
                                                </div>
                                                {validator.message('rating', formData.rating, 'required')}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <label>
                                                    {this.props.t('feedback.feedback', { param: 'react' })} :
                                                    <span className="errorclr ml-2" aria-hidden="true">*</span>
                                                    <span className="sr-only">required</span>
                                                </label>
                                                <textarea
                                                    aria-label='Enter your feedback'
                                                    className="w-100 p-1 form-control"
                                                    onChange={this.change}
                                                    value={formData.feedback || ''}
                                                    placeholder={this.props.t('forms.enterFeedback', { param: 'react' })}
                                                    name="feedback"
                                                    id="feedback"
                                                    rows="4"
                                                    aria-required="true"
                                                />
                                                {validator.message('feedback', formData.feedback, 'required')}
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-primary2 mx-auto d-block"
                                                    style={{ marginRight: '10px' }}
                                                    aria-label="Submit Feedback"
                                                >
                                                    {this.props.t('feedback.submit', { param: 'react' })}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>


                <section className="footer afterclass">
                    <div className="container">
                        <div className="row footer-border  ml-0">
                            <div className="col-md-12 col-sm-12 col-lg-12 first2">
                                {/* <ul className="mx-auto mb-0">
                                    <li className="list-inline-item">
                                        <ul style={{ "cursor": "pointer" }}>
                                            <li className="list-inline-item" data-toggle="modal" onClick={() => {
                                                this.setState({ formData: [] })
                                                this.props.validator.hideMessages()
                                            }} data-target="#feedbackModal"><span><img
                                                src={"/images/icon-feedback.png"}
                                                alt={"feedback-icon"}
                                                style={{ "height": "25px" }} /></span> {this.props.t('footer.give_feedback', { param: 'react' })}
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="list-inline-item"><Link to="/contact-us"><span><img
                                        src={"/images/icon-contact.png"}
                                        alt={"contact-us-icon"}
                                        style={{ "height": "25px" }} /></span> {this.props.t('footer.contact_us', { param: 'react' })}
                                    </Link></li>
                                    <li className="list-inline-item"><Link to="/sitemap"
                                    >  {this.props.t('footer.Sitemap', { param: 'react' })}</Link>
                                    </li>
                                    <li className="list-inline-item"><Link to="/help"
                                    >  {this.props.t('footer.Help', { param: 'react' })}</Link>
                                    </li> */}


                                {/* <li className="list-inline-item"><Link to="/uniceff"
                                >  AI Tools -UNICEF </Link>
                                </li> */}


                                {/* </ul> */}



                            </div>

                            <div className="col-md-12 col-sm-12 col-lg-12 first2">
                                <ul className="mx-auto mb-0 overflow-hidden">
                                    {/* <h6 className="text-center mb-0">{this.props.t('homeContent.disclaimer', {param: 'react'})}</h6> */}
                                    <li className="my-0">
                                        <div className={`announcement-ticker ${this.state.isNotificationPaused ? 'paused' : ''}`} aria-live="polite">
                                            <p
                                                className="mb-1 "  >
                                                <b className="blinking" style={{ "fontSize": "16", "background": "none" }}>{this.props.t('homeContent.disclaimer', { param: 'react' })}:
                                                </b> {this.props.t('homeContent.disclaimerText', { param: 'react' })}</p>

                                        </div>
                                        {/* <marquee
                                            scrolldelay="150"
                                            ref={this.disclaimer}>
                                            <p onMouseLeave={(e) => this.disclaimer.current.start()}
                                                onMouseEnter={(e) => this.disclaimer.current.stop()}
                                                className="mb-1 "  >
                                                <b className="blinking" style={{ "fontSize": "14", "background": "none" }}>{this.props.t('homeContent.disclaimer', { param: 'react' })}:
                                                </b> {this.props.t('homeContent.disclaimerText', { param: 'react' })}</p>
                                        </marquee> */}
                                    </li>
                                </ul>
                            </div>

                            <div className="col-lg-12">
                                <div className="footer-copy-text">
                                    <span className='copyright-text wesfwe'>
                                        {this.props.t('footer.Portal_is_best_viewed', { param: 'react' })}

                                    </span>
                                    <p className="copyright-text">
                                        © {new Date().getFullYear()}, {this.props.t('footer.all_right_reserved', { param: 'react' })}{" "}
                                    </p>


                                </div>

                            </div>





                            {/* <div className=" col-lg-4  col-sm-4 pt-2 education-copyright">
                                <p className="pull-right"><span>{this.props.t('footer.created_by', { param: 'react' })} <a
                                    href="https://www.drishinfo.com/"
                                    rel="noopener noreferrer"
                                    target="_blank">{this.props.t('footer.drish', { param: 'react' })}.</a></span></p>
                            </div> */}
                        </div>


                    </div>



                </section>


                <div className="clearfix"></div>
            </footer>
        );
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(Validation(Footer)));
